module.exports = __webpack_public_path__ + "static/media/download.cda5be10.svg";